import { render } from "./i-cpf-cnpj.vue?vue&type=template&id=df810986&scoped=true"
import script from "./i-cpf-cnpj.vue?vue&type=script&lang=js"
export * from "./i-cpf-cnpj.vue?vue&type=script&lang=js"

import "./i-cpf-cnpj.vue?vue&type=style&index=0&id=df810986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df810986"]])

export default __exports__